import styled from 'styled-components';

type Props = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};

const Padding = styled.div<Props>`
  padding-top: ${({ top }): number => top || 0}px;
  padding-right: ${({ right }): number => right || 0}px;
  padding-bottom: ${({ bottom }): number => bottom || 0}px;
  padding-left: ${({ left }): number => left || 0}px;
`;
Padding.displayName = 'Padding';

export default Padding;
